import React, { useEffect, useState } from "react";
import headerContactUs from "../images/map/Slide-6.webp";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import i18next from "i18next";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import emailjs from "emailjs-com"; // Import EmailJS SDK
import { parsePhoneNumberFromString } from "libphonenumber-js";

// Success Modal
const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const currentLanguageCode = cookies.get("i18next") || "en";
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-[50%] md:w-[80%]">
        <h2 className="text-green-500 text-center text-2xl">
          {currentLanguageCode === "ar" ? "تم الإرسال" : "Success!"}
        </h2>
        <p className="text-center mt-4">
          {currentLanguageCode === "ar"
            ? "شكرًا لتواصلك معنا. سنقوم بالرد عليك في أقرب وقت ممكن"
            : "Thank you for reaching out. We will get back to you as soon as possible."}
        </p>

        <div className="flex justify-center mt-6">
          <button
            onClick={onClose}
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            {currentLanguageCode === "ar" ? "إغلاق" : "Close"}
          </button>
        </div>
      </div>
    </div>
  );
};

// Error Modal
const ErrorModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const currentLanguageCode = cookies.get("i18next") || "en";
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-[50%] md:w-[90%]">
        <h2 className="text-red-500 text-center text-2xl">
          {currentLanguageCode === "ar" ? "خطأ" : "Error!"}
        </h2>
        <p className="text-center mt-4">
          {currentLanguageCode === "ar"
            ? "حدثت مشكلة أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى"
            : "There was an issue sending your message. Please try again."}
        </p>

        <div className="flex justify-center mt-6">
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-2 rounded"
          >
            {currentLanguageCode === "ar" ? "إغلاق" : "Close"}
          </button>
        </div>
      </div>
    </div>
  );
};

function ContactUs() {
  const [phoneValue, setPhoneValue] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [propertyType, setPropertyType] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [loadingSending, setLoadingSending] = useState(false);

  const currentLanguageCode = cookies.get("i18next") || "en";
  const handleCheckboxChange = (value) => {
    setPropertyType((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const parsedPhoneNumber = parsePhoneNumberFromString(phoneValue);
  const countryCode = parsedPhoneNumber ? parsedPhoneNumber.country : "";

  const formData = {
    name,
    email,
    countryCode,
    phoneNumber: phoneValue,
    propertyType: propertyType.join(", "),
    message,
  };

  try {
    setLoadingSending(true);

    // Send email to customer
    await emailjs.send(
      "service_vs9w4ur",
      "template_x9rzh0j",
      formData,
      "XcpLTArK2iU7J9HRe"
    );

    // Send email to admin
   await emailjs.send(
     "service_vs9w4ur",
     "template_p0m40kb", // Your customer template
     formData,
     "XcpLTArK2iU7J9HRe"
   );

    setShowSuccessModal(true);
    setName("");
    setEmail("");
    setPhoneValue("");
    setMessage("");
    setPropertyType([]);
  } catch (error) {
    console.error("Error submitting form:", error);
    setShowErrorModal(true);
  } finally {
    setLoadingSending(false);
  }
};

  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="flex justify-center items-center relative font-[cairo] w-fit font-[300] tracking-widest">
        <div className="md:h-[50vh]">
          <img
            alt=""
            className="w-[100%] h-[100%] object-cover"
            src={headerContactUs}
          />
        </div>
        <div className="absolute flex justify-center items-center flex-col text-center w-fit top-[40%]">
          <p className="text-[white] w-[80%] text-[3vw] md:text-[20px] md:w-[90%] bg-[#202020c2]">
            {t("contact.title")}
          </p>
          <p className="text-[2vw] md:text-[12px] text-[white] bg-[#202020c2] font-[100] px-[1%]">
            {t("contact.subtitle")}
          </p>
        </div>
      </div>

      {/* Contact Form */}
      <div
        className={`w-[100%] lg:flex-col-reverse lg:gap-[10px] flex ${
          currentLanguageCode === "ar" && "flex-row-reverse"
        } justify-between items-center p-[3%] sm:p-[1%]`}
      >
        <div className="w-[45%] h-[80vh] lg:h-[50vh] lg:w-[100%] ">
          <iframe
            className="object-contain rounded-[20px] h-[100%] w-[100%] "
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3198.410722567084!2d58.272028999999996!3d23.6284741!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8dfd411985e225%3A0x6a9bfe3adf52e6f9!2sSarooj%20Development!5e1!3m2!1sen!2slb!4v1758391268491!5m2!1sen!2slb"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>

        <div
          className={`${
            currentLanguageCode === "ar" && "text-right"
          }  w-[50%] py-[3%] lg:w-[100%] bg-[#000000d3] flex justify-center items-center h-[100%]`}
        >
          <form
            onSubmit={handleSubmit}
            className="flex justify-between gap-[15px] xl:gap-[10px]  p-[5%] flex-col"
          >
            <h1 className="text-[3vw] lg:text-[5vw] md:text-[6vw] font-[cairo] font-[300] text-white">
              {t("contact.form.title")}
            </h1>
            <div className="flex flex-col font-[cairo]">
              <label
                htmlFor="fullName1"
                className="mb-[5px] text-[18px] text-white"
              >
                {t("contact.form.name")}{" "}
                <span className="text-[#ecc55e]">*</span>
              </label>
              <input
                id="fullName1"
                required
                className="border-[1px] p-[10px]"
                value={name}
                dir={currentLanguageCode === "ar" ? "rtl" : "ltr"}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="email"
                className="mb-[5px] text-[18px] text-white"
              >
                {t("contact.form.email")}{" "}
                <span className="text-[#ecc55e]">*</span>
              </label>
              <input
                id="email"
                required
                className="border-[1px] p-[10px]"
                value={email}
                dir={currentLanguageCode === "ar" ? "rtl" : "ltr"}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="phone"
                className="mb-[5px] text-[18px] text-white"
              >
                {t("contact.form.phone")}{" "}
                <span className="text-[#ecc55e]">*</span>
              </label>
              <PhoneInput
                id="phone"
                international
                defaultCountry="OM"
                value={phoneValue}
                onChange={setPhoneValue}
                className="border-[1px] p-[10px]"
              />
            </div>

            <div className="flex flex-col">
              <label className="mb-[5px] text-[18px] text-white">
                {t("contact.form.type.title")}{" "}
                <span className="text-[#ecc55e]">*</span>
              </label>
              <div className="flex flex-wrap gap-[10px]">
                {[
                  {
                    id: "ALTHURAYA VILLAS",
                    label: t("navbar.community.villas"),
                  },
                  { id: "AHED VILLAS", label: t("navbar.community.ahed") },
                  {
                    id: "One Bedroom Apartment",
                    label: t("contact.form.type.option1"),
                  },
                  {
                    id: "Two Bedroom Apartment",
                    label: t("contact.form.type.option2"),
                  },
                  {
                    id: "Three Bedroom",
                    label: t("contact.form.type.option3"),
                  },
                  {
                    id: "Commercial Space",
                    label: t("contact.form.type.option4"),
                  },
                ].map((type) => (
                  <label
                    key={type.id}
                    htmlFor={type.id}
                    className="flex items-center w-[250px] text-white cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      id={type.id}
                      value={type.id}
                      checked={propertyType.includes(type.id)}
                      onChange={() => handleCheckboxChange(type.id)}
                      className={`w-4 h-4 cursor-pointer appearance-none border-2 rounded-full border-white checked:bg-white`}
                    />

                    <span className="ml-2">{type.label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="message"
                className="mb-[5px] text-[18px] text-white"
              >
                {t("contact.form.message")}{" "}
                <span className="text-[#ecc55e]">*</span>
              </label>
              <textarea
                id="message"
                required
                className="border-[1px] p-[10px] h-[10vh]"
                value={message}
                dir={currentLanguageCode === "ar" ? "rtl" : "ltr"}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="px-[4%] py-[1%] border-[1px] hover:bg-[WHITE] text-[white] hover:text-[gray]"
                disabled={loadingSending}
              >
                {loadingSending ? "Loading..." : t("contact.form.submit")}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Success and Error Modals */}
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      />

      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
      />
    </>
  );
}

export default ContactUs;
